'use client';

import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import React from 'react';
import TableBody from './TableBody';
import TableHead from './TableHead';
import TableCell from './TableCell';
import TableHeaderCell from './TableHeaderCell';
import TableRow from './TableRow';
import TableNoRows from './TableNoRows';
import TableProvider from './TableProvider';
type TableProps = {
  children: React.ReactNode;
  className?: string;
  head: React.ReactNode;
  'data-testid'?: string;
};
export default function Table(t0) {
  const $ = _c(14);
  const {
    children,
    head,
    className,
    "data-testid": testId
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cx("max-sm:-mx-6 overflow-x-auto overflow-y-visible text-base font-normal leading-6 text-blue-500", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== head) {
    t2 = head && <TableHead className="max-sm:hidden">{head}</TableHead>;
    $[2] = head;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== children || $[5] !== t2) {
    t3 = <table className="relative min-w-full divide-y divide-blue-200">{t2}{children}</table>;
    $[4] = children;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== head || $[8] !== t3) {
    t4 = <TableProvider head={head}>{t3}</TableProvider>;
    $[7] = head;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t1 || $[11] !== t4 || $[12] !== testId) {
    t5 = <div data-testid={testId} className={t1}>{t4}</div>;
    $[10] = t1;
    $[11] = t4;
    $[12] = testId;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}
Table.Body = TableBody;
Table.Head = TableHead;
Table.Cell = TableCell;
Table.HeaderCell = TableHeaderCell;
Table.Row = TableRow;
Table.NoRows = TableNoRows;
export { TableBody, TableHead, TableCell, TableHeaderCell, TableRow, TableNoRows };